import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import MasterService from '../../services/MasterService';
import './Login.scss';

const Login = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const loginInitiated = React.useRef(false);

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const userdata = urlParams.get('userdata');

        if (userdata && !loginInitiated.current) {
            loginInitiated.current = true;
            try {
                const parsedUserData = JSON.parse(userdata);
                if (parsedUserData && parsedUserData.email) {
                    performBackendLogin(parsedUserData.email);
                }
            } catch (err) {
                console.error('Error parsing userdata:', err);
                setError('Authentication failed. Invalid response from SSO.');
            }
        }
    }, [navigate]);

    const performBackendLogin = async (email) => {
        setLoading(true);
        setError('');
        try {
            const response = await MasterService.login({
                email: email,
                isGoogleLogin: true
            });

            if (response && response.status === 200 && response.data) {
                const { token, refresh_token, user_data } = response.data;
                
                // Store in localStorage
                localStorage.setItem('authToken', token);
                localStorage.setItem('refreshToken', refresh_token);
                localStorage.setItem('user', JSON.stringify(user_data));

                // Clean up the URL
                window.history.replaceState({}, document.title, "/");

                // Redirect to dashboard
                navigate('/dashboard');
            }
        } catch (err) {
            console.error('Login error:', err);
            setError(err.message || 'Login failed. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    const handleGoogleLogin = () => {
        const SSO_URL = process.env.REACT_APP_SSO_URL;
        const SITE_URL = process.env.REACT_APP_SITE_URL;
        const loginUrl2send = `${SSO_URL}/google?redirect=${SITE_URL}`;
        window.location.href = loginUrl2send;
    };

    return (
        <div className="login-container">
            <div className="login-left-panel">
                <div className="logo-section">
                    <div className="logo">
                        <span className="logo-icon">📊</span>
                        <span className="logo-text">RECON</span>
                    </div>
                </div>

                <div className="welcome-section">
                    <h1 className="welcome-title">Welcome Team</h1>
                    <h2 className="portal-title">Recon Portal</h2>
                </div>

                <div className="illustration">
                    <img
                        src="/login-illustration.png"
                        alt="Business Analytics Illustration"
                        className="illustration-image"
                    />
                </div>
            </div>

            <div className="login-right-panel">
                <div className="login-form-container">
                    <h2 className="login-title">Log In</h2>

                    {error && (
                        <div className="error-message">
                            {error}
                        </div>
                    )}

                    <button
                        className="google-login-btn"
                        onClick={handleGoogleLogin}
                        disabled={loading}
                    >
                        <svg className="google-icon" viewBox="0 0 24 24" width="20" height="20">
                            <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
                            <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
                            <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" />
                            <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />
                        </svg>
                        <span>{loading ? 'Signing in...' : 'Sign in with Google'}</span>
                    </button>

                    <div className="demo-note">
                        {/* <small>Demo Mode: Click to login with mock credentials</small> */}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Login;
